import classes from "./AboutPage.module.css";
import React from "react";
import Logo from "./devquiz.png";

const AboutPage = (props) => {
  return (
    <div className={classes.AboutPage}>
      <div>
        <img className={classes.Logo} src={Logo} alt="DEV Quiz" />
        <p className={classes.Description}>
          Designed by a <strong>Junior Dev Community</strong>.
        </p>
        <p className={classes.Description}>
          Share your comments at{" "}
          <a href="mailto:support@techytraders.com">support@techytraders.com</a>
        </p>
        <h2 className={classes.TechnologiesTitle}>Tools & Libraries Used</h2>
        <ul className={classes.TechnologiesList}>
          <li>
            <p>
              <strong>React</strong> -{" "}
              <a href="https://reactjs.org/">https://reactjs.org/</a>
            </p>
          </li>
          <li>
            <p>
              <strong>Redux</strong> -{" "}
              <a href="https://redux.js.org/">https://redux.js.org/</a>
            </p>
          </li>
          <li>
            <p>
              <strong>Saga</strong> -{" "}
              <a href="https://redux-saga.js.org/">
                https://redux-saga.js.org/
              </a>
            </p>
          </li>
          <li>
            <p>
              <strong>Firebase</strong> -{" "}
              <a href="https://firebase.google.com/docs">
                https://firebase.google.com/
              </a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutPage;
